export default {
  root: {
    backgroundColor: "#fafafa",
  },
};
